import { AlertButton } from "@ionic/vue";
import Translator from "@/plugins/Translator";
import { AlertRoles } from "@/models/AlertButtons/AlertRoles";

const translator = Translator.getInstance();
const i18n = translator.getI18nGlobalInstance();

/**
 * UI Button um etwas zu löschen
 */
export const DeleteButton: AlertButton = {
	role: AlertRoles.DELETE,
	text: i18n.t("actions.delete"),
};
